import { useRef, useEffect } from 'preact/hooks';

/**
 *保存上一次状态的 Hook
 */
export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
